import React, {useState} from 'react';
import classnames from 'classnames';
import Validate, {Alert} from 'react-form-controlled-validate';
import {Form, Input} from 'react-form-controlled';
import {FormattedMessage} from 'react-intl';

const shareViaEmailSchema = {
  type: 'object',
  properties: {
    email: {
      type: 'string',
      format: 'email'
    }
  },
  required: ['email']
};

const ShareViaEmail = ({className, onSubmit, sendEmail, initialValue = null}) => {

  const classes = classnames(className, 'shareViaEmail');
  const [formData, updateFormData] = useState({email: initialValue});

  const onChange = (data) => {
    updateFormData(data);
  };

  const onFormSubmit = (data) => {
    sendEmail(data.email);
    onSubmit();
  };


  return <section className={classes}>
    <Validate schema={shareViaEmailSchema}>
      <Form onSubmit={onFormSubmit} value={formData} onChange={onChange}>
        <FormattedMessage id="shareViaEmail.label" tagName="label"/>
        <Input aria-label="email" type="text" debounce={0} name="email"/>
        <Alert name="email" className="form-alert"/>
        <button type="submit" className="btn"><FormattedMessage id="shareViaEmail.button"/></button>
      </Form>
    </Validate>
  </section>;
};

export default ShareViaEmail;
